const imageTypes = {
  1: 'Exterior',
  2: 'Interior',
  3: 'Mechanical',
  4: 'Docs',
  5: 'Other',
  'Exterior': 1,
  'Interior': 2,
  'Mechanical': 3,
  'Docs': 4,
  'Other': 5,
}

export default imageTypes
